export default __webpack_public_path__ + "static/media/logo.89827c5b.jpg";